<script setup>
// @ts-check

import * as _ from 'lodash-es'
import { computed, nextTick, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'

defineProps({
  disabledRoutes: {
    type: Array,
    default: () => []
  }
})

defineOptions({
  name: 'RouteSelect'
})

const currentRoute = useRoute()

const { t } = useI18n()

const routes = computed(() => _.first(currentRoute.matched)?.children ?? [])

const selectedRoute = ref(currentRoute)

const isMenuOpen = ref(false)

const onSelect = (route) => {
  selectedRoute.value = route.raw

  nextTick(() => {
    isMenuOpen.value = false
  })
}
</script>

<template>
  <VSelect
    v-model="selectedRoute"
    v-model:menu="isMenuOpen"
    :items="routes"
    :aria-label="t('general.select_page')"
    item-children="children"
    return-object
    :item-props="
      (item) => ({
        value: item.name,
        title: t(`routes.${item.name?.toString()}`)
      })
    "
  >
    <template #item="{ item: route, props: routeProps }">
      <VListItem
        role="option"
        :to="{ name: route.value }"
        :disabled="disabledRoutes.includes(route.value)"
        v-bind="routeProps"
        :class="{
          strict: route.value === currentRoute.name
        }"
      />
      <template v-if="!route.raw.meta?.hideSubroutes">
        <VListItem
          v-for="childRoute in route.children ?? []"
          :key="childRoute.value"
          role="option"
          :to="{ name: childRoute.value }"
          class="pl-8!"
          :disabled="disabledRoutes.includes(childRoute.value)"
          v-bind="childRoute.props"
          :class="{
            strict: childRoute.value === currentRoute.name
          }"
          @click="onSelect(childRoute)"
        />
      </template>
    </template>
  </VSelect>
</template>

<style lang="scss" scoped>
@reference '../../styles/main.css';

.v-list-item--active {
  :deep(.v-list-item-title) {
    @apply font-medium!;
  }

  &:not(.strict) {
    :deep(.v-list-item__overlay) {
      @apply bg-white;
    }
  }
}
</style>
